import { useNewTranslation } from 'hooks/index'
import React from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { theme } from 'theme'
import LinkButton from 'components/Shared/Button/LinkButton'

export const DetailModalCell = (cellParams: GridRenderCellParams): JSX.Element => {
    const [newT] = useNewTranslation()
    return (
        <LinkButton
            href={'#'}
            onClick={(e): void => {
                if (e) {
                    e.preventDefault()
                }
                cellParams.value.onOpenActionDetailModal(cellParams.row.action)
            }}
            style={{
                wordBreak: 'break-all',
                fontSize: theme.newFontSizes.m,
                fontWeight: theme.fontWeight.medium,
                lineHeight: theme.lineHeight.l,
            }}
            value={newT('button.seeDetails', 'See Details')}
        />
    )
}
